import { useQuery } from '@tanstack/react-query';
import { listTriggerSubscriptions } from '@/services/triggers/triggers';
import { TriggerSubscription } from '@/services/triggers/types';

export const triggerSubscriptionsQueryKey = (
  orgId?: string,
  triggerId?: string,
) => ['trigger-subscriptions', orgId, triggerId];

export const useListTriggerSubscriptions = (
  orgId?: string,
  triggerId?: string,
) =>
  useQuery<TriggerSubscription[]>({
    queryKey: triggerSubscriptionsQueryKey(orgId, triggerId),
    queryFn: () => listTriggerSubscriptions(orgId!, triggerId!),
    enabled: !!orgId && !!triggerId,
  });
